import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { Result, mappingResultError } from '@digibricks/domains';
import { FILE_STORAGE_REPOSITORY } from '../../core';
import { FILE_STORAGE_API } from '../data-sources';
import { FileStorageMapper } from './file-storage.mapper';
export var FileStorageRepository = /*#__PURE__*/function () {
  function FileStorageRepository(fileStorageApi, fileStorageMapper) {
    _classCallCheck(this, FileStorageRepository);

    this.fileStorageApi = fileStorageApi;
    this.fileStorageMapper = fileStorageMapper;
  }

  _createClass(FileStorageRepository, [{
    key: "createFormCategoryLogo",
    value: function () {
      var _createFormCategoryLogo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var responseOrError, responseValue, fileStorageDomainOrError;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.fileStorageApi.createFormCategoryLogo(input);

              case 2:
                responseOrError = _context.sent;

                if (!responseOrError.isFailure) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", mappingResultError(responseOrError));

              case 5:
                responseValue = responseOrError.getValue();
                fileStorageDomainOrError = this.fileStorageMapper.toDomain(responseValue);

                if (!fileStorageDomainOrError.isFailure) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", Result.fail(fileStorageDomainOrError.error));

              case 9:
                return _context.abrupt("return", Result.ok(fileStorageDomainOrError.getValue()));

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createFormCategoryLogo(_x) {
        return _createFormCategoryLogo.apply(this, arguments);
      }

      return createFormCategoryLogo;
    }()
  }, {
    key: "createFormThumbnail",
    value: function () {
      var _createFormThumbnail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(input) {
        var responseOrError, responseValue, fileStorageDomainOrError;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.fileStorageApi.createFormThumbnail(input);

              case 2:
                responseOrError = _context2.sent;

                if (!responseOrError.isFailure) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", mappingResultError(responseOrError));

              case 5:
                responseValue = responseOrError.getValue();
                fileStorageDomainOrError = this.fileStorageMapper.toDomain(responseValue);

                if (!fileStorageDomainOrError.isFailure) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return", Result.fail(fileStorageDomainOrError.error));

              case 9:
                return _context2.abrupt("return", Result.ok(fileStorageDomainOrError.getValue()));

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function createFormThumbnail(_x2) {
        return _createFormThumbnail.apply(this, arguments);
      }

      return createFormThumbnail;
    }()
  }, {
    key: "createTagIcon",
    value: function () {
      var _createTagIcon = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(input) {
        var responseOrError, responseValue, fileStorageDomainOrError;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.fileStorageApi.createTagIcon(input);

              case 2:
                responseOrError = _context3.sent;

                if (!responseOrError.isFailure) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return", mappingResultError(responseOrError));

              case 5:
                responseValue = responseOrError.getValue();
                fileStorageDomainOrError = this.fileStorageMapper.toDomain(responseValue);

                if (!fileStorageDomainOrError.isFailure) {
                  _context3.next = 9;
                  break;
                }

                return _context3.abrupt("return", Result.fail(fileStorageDomainOrError.error));

              case 9:
                return _context3.abrupt("return", Result.ok(fileStorageDomainOrError.getValue()));

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function createTagIcon(_x3) {
        return _createTagIcon.apply(this, arguments);
      }

      return createTagIcon;
    }()
  }, {
    key: "createMarkdownEditorImage",
    value: function () {
      var _createMarkdownEditorImage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(input) {
        var responseOrError, responseValue, fileStorageDomainOrError;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.fileStorageApi.createMarkdownEditorImage(input);

              case 2:
                responseOrError = _context4.sent;

                if (!responseOrError.isFailure) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return", mappingResultError(responseOrError));

              case 5:
                responseValue = responseOrError.getValue();
                fileStorageDomainOrError = this.fileStorageMapper.toDomain(responseValue);

                if (!fileStorageDomainOrError.isFailure) {
                  _context4.next = 9;
                  break;
                }

                return _context4.abrupt("return", Result.fail(fileStorageDomainOrError.error));

              case 9:
                return _context4.abrupt("return", Result.ok(fileStorageDomainOrError.getValue()));

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function createMarkdownEditorImage(_x4) {
        return _createMarkdownEditorImage.apply(this, arguments);
      }

      return createMarkdownEditorImage;
    }()
  }, {
    key: "createMarkdownEditorAudio",
    value: function () {
      var _createMarkdownEditorAudio = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(input) {
        var responseOrError, responseValue, fileStorageDomainOrError;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.fileStorageApi.createMarkdownEditorAudio(input);

              case 2:
                responseOrError = _context5.sent;

                if (!responseOrError.isFailure) {
                  _context5.next = 5;
                  break;
                }

                return _context5.abrupt("return", mappingResultError(responseOrError));

              case 5:
                responseValue = responseOrError.getValue();
                fileStorageDomainOrError = this.fileStorageMapper.toDomain(responseValue);

                if (!fileStorageDomainOrError.isFailure) {
                  _context5.next = 9;
                  break;
                }

                return _context5.abrupt("return", Result.fail(fileStorageDomainOrError.error));

              case 9:
                return _context5.abrupt("return", Result.ok(fileStorageDomainOrError.getValue()));

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function createMarkdownEditorAudio(_x5) {
        return _createMarkdownEditorAudio.apply(this, arguments);
      }

      return createMarkdownEditorAudio;
    }()
  }, {
    key: "updateFile",
    value: function () {
      var _updateFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(input) {
        var responseOrError, responseValue;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.fileStorageApi.updateFile(input);

              case 2:
                responseOrError = _context6.sent;

                if (!responseOrError.isFailure) {
                  _context6.next = 5;
                  break;
                }

                return _context6.abrupt("return", mappingResultError(responseOrError));

              case 5:
                responseValue = responseOrError.getValue();
                return _context6.abrupt("return", Result.ok(responseValue));

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function updateFile(_x6) {
        return _updateFile.apply(this, arguments);
      }

      return updateFile;
    }()
  }, {
    key: "createSectionFile",
    value: function () {
      var _createSectionFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(input) {
        var responseOrError, responseValue, fileStorageDomainOrError;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.fileStorageApi.createSectionFile(input);

              case 2:
                responseOrError = _context7.sent;

                if (!responseOrError.isFailure) {
                  _context7.next = 5;
                  break;
                }

                return _context7.abrupt("return", mappingResultError(responseOrError));

              case 5:
                responseValue = responseOrError.getValue();
                fileStorageDomainOrError = this.fileStorageMapper.toDomain(responseValue);

                if (!fileStorageDomainOrError.isFailure) {
                  _context7.next = 9;
                  break;
                }

                return _context7.abrupt("return", Result.fail(fileStorageDomainOrError.error));

              case 9:
                return _context7.abrupt("return", Result.ok(fileStorageDomainOrError.getValue()));

              case 10:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function createSectionFile(_x7) {
        return _createSectionFile.apply(this, arguments);
      }

      return createSectionFile;
    }()
  }, {
    key: "createQuestionFile",
    value: function () {
      var _createQuestionFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(input) {
        var responseOrError, responseValue, fileStorageDomainOrError;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.fileStorageApi.createQuestionFile(input);

              case 2:
                responseOrError = _context8.sent;

                if (!responseOrError.isFailure) {
                  _context8.next = 5;
                  break;
                }

                return _context8.abrupt("return", mappingResultError(responseOrError));

              case 5:
                responseValue = responseOrError.getValue();
                fileStorageDomainOrError = this.fileStorageMapper.toDomain(responseValue);

                if (!fileStorageDomainOrError.isFailure) {
                  _context8.next = 9;
                  break;
                }

                return _context8.abrupt("return", Result.fail(fileStorageDomainOrError.error));

              case 9:
                return _context8.abrupt("return", Result.ok(fileStorageDomainOrError.getValue()));

              case 10:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function createQuestionFile(_x8) {
        return _createQuestionFile.apply(this, arguments);
      }

      return createQuestionFile;
    }()
  }, {
    key: "createProfileFile",
    value: function () {
      var _createProfileFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(input) {
        var responseOrError, responseValue, fileStorageDomainOrError;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.fileStorageApi.createProfileFile(input);

              case 2:
                responseOrError = _context9.sent;

                if (!responseOrError.isFailure) {
                  _context9.next = 5;
                  break;
                }

                return _context9.abrupt("return", mappingResultError(responseOrError));

              case 5:
                responseValue = responseOrError.getValue();
                fileStorageDomainOrError = this.fileStorageMapper.toDomain(responseValue);

                if (!fileStorageDomainOrError.isFailure) {
                  _context9.next = 9;
                  break;
                }

                return _context9.abrupt("return", Result.fail(fileStorageDomainOrError.error));

              case 9:
                return _context9.abrupt("return", Result.ok(fileStorageDomainOrError.getValue()));

              case 10:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function createProfileFile(_x9) {
        return _createProfileFile.apply(this, arguments);
      }

      return createProfileFile;
    }()
  }, {
    key: "createQuestionAnswerFile",
    value: function () {
      var _createQuestionAnswerFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(input) {
        var responseOrError, responseValue, fileStorageDomainOrError;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.fileStorageApi.createQuestionAnswerFile(input);

              case 2:
                responseOrError = _context10.sent;

                if (!responseOrError.isFailure) {
                  _context10.next = 5;
                  break;
                }

                return _context10.abrupt("return", mappingResultError(responseOrError));

              case 5:
                responseValue = responseOrError.getValue();
                fileStorageDomainOrError = this.fileStorageMapper.toDomain(responseValue);

                if (!fileStorageDomainOrError.isFailure) {
                  _context10.next = 9;
                  break;
                }

                return _context10.abrupt("return", Result.fail(fileStorageDomainOrError.error));

              case 9:
                return _context10.abrupt("return", Result.ok(fileStorageDomainOrError.getValue()));

              case 10:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function createQuestionAnswerFile(_x10) {
        return _createQuestionAnswerFile.apply(this, arguments);
      }

      return createQuestionAnswerFile;
    }()
  }, {
    key: "createSubmissionAnswerFile",
    value: function () {
      var _createSubmissionAnswerFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(input) {
        var responseOrError, responseValue, fileStorageDomainOrError;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.fileStorageApi.createSubmissionAnswerFile(input);

              case 2:
                responseOrError = _context11.sent;

                if (!responseOrError.isFailure) {
                  _context11.next = 5;
                  break;
                }

                return _context11.abrupt("return", mappingResultError(responseOrError));

              case 5:
                responseValue = responseOrError.getValue();
                fileStorageDomainOrError = this.fileStorageMapper.toDomain(responseValue);

                if (!fileStorageDomainOrError.isFailure) {
                  _context11.next = 9;
                  break;
                }

                return _context11.abrupt("return", Result.fail(fileStorageDomainOrError.error));

              case 9:
                return _context11.abrupt("return", Result.ok(fileStorageDomainOrError.getValue()));

              case 10:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function createSubmissionAnswerFile(_x11) {
        return _createSubmissionAnswerFile.apply(this, arguments);
      }

      return createSubmissionAnswerFile;
    }()
  }, {
    key: "saveFile",
    value: function () {
      var _saveFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(input) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.fileStorageApi.saveFile(input);

              case 2:
                responseOrError = _context12.sent;

                if (!responseOrError.isFailure) {
                  _context12.next = 5;
                  break;
                }

                return _context12.abrupt("return", mappingResultError(responseOrError));

              case 5:
                return _context12.abrupt("return", Result.ok());

              case 6:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function saveFile(_x12) {
        return _saveFile.apply(this, arguments);
      }

      return saveFile;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(input) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.fileStorageApi["delete"](input);

              case 2:
                responseOrError = _context13.sent;

                if (!responseOrError.isFailure) {
                  _context13.next = 5;
                  break;
                }

                return _context13.abrupt("return", mappingResultError(responseOrError));

              case 5:
                return _context13.abrupt("return", Result.ok());

              case 6:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function _delete(_x13) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "createAiAttachmentFile",
    value: function () {
      var _createAiAttachmentFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(input) {
        var responseOrError, responseValue, fileStorageDomainOrError;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.fileStorageApi.createAiAttachmentFile(input);

              case 2:
                responseOrError = _context14.sent;

                if (!responseOrError.isFailure) {
                  _context14.next = 5;
                  break;
                }

                return _context14.abrupt("return", mappingResultError(responseOrError));

              case 5:
                responseValue = responseOrError.getValue();
                fileStorageDomainOrError = this.fileStorageMapper.toDomain(responseValue);

                if (!fileStorageDomainOrError.isFailure) {
                  _context14.next = 9;
                  break;
                }

                return _context14.abrupt("return", Result.fail(fileStorageDomainOrError.error));

              case 9:
                return _context14.abrupt("return", Result.ok(fileStorageDomainOrError.getValue()));

              case 10:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function createAiAttachmentFile(_x14) {
        return _createAiAttachmentFile.apply(this, arguments);
      }

      return createAiAttachmentFile;
    }()
  }, {
    key: "validatePublicFileUrl",
    value: function () {
      var _validatePublicFileUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(input) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this.fileStorageApi.validatePublicFileUrl(input);

              case 2:
                responseOrError = _context15.sent;

                if (!responseOrError.isFailure) {
                  _context15.next = 5;
                  break;
                }

                return _context15.abrupt("return", mappingResultError(responseOrError));

              case 5:
                return _context15.abrupt("return", Result.ok(responseOrError.getValue()));

              case 6:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function validatePublicFileUrl(_x15) {
        return _validatePublicFileUrl.apply(this, arguments);
      }

      return validatePublicFileUrl;
    }()
  }]);

  return FileStorageRepository;
}();
export var fileStorageRepositoryProvider = {
  provide: FILE_STORAGE_REPOSITORY,
  useFactory: function useFactory(fileStorageApi, mapper) {
    return new FileStorageRepository(fileStorageApi, mapper);
  },
  inject: [FILE_STORAGE_API, FileStorageMapper]
};